import { render, staticRenderFns } from "./costingitem.vue?vue&type=template&id=ba702478"
import script from "./costingitem.vue?vue&type=script&lang=js"
export * from "./costingitem.vue?vue&type=script&lang=js"
import style0 from "./costingitem.vue?vue&type=style&index=0&id=ba702478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports